import { getConstants } from "@utilifiles/methods/storage/storage";
import {
  emptyError,
  ResponseType,
} from "../../../Types/ServicesType/servicesType";
import {
  billedItemResponseType,
  getbilledItemDetailsResponseType,
  getbilledItemPayloadType,
  paidListResponseType,
  patientPayDetailsBIllsNoAndDates,
  PaymentData,
} from "./type";
import api from "@services/apiList";
import instance, { errorResponse } from "@services/services";

const { clinicId } = getConstants();
const { cashierApi } = api;

export const getBilledItemService = async (
  data: getbilledItemPayloadType,
): Promise<ResponseType<billedItemResponseType | null>> => {
  console.log(data);
  try {
    const result = await instance.post(cashierApi.getbilledPatientsv2, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPaidListService = async (
  data: getbilledItemPayloadType,
): Promise<ResponseType<paidListResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getCashierbilldetails, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPaidListServicepartial = async (
  data: getbilledItemPayloadType,
): Promise<ResponseType<paidListResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getCashierbilldetailsforpartial, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const patientientPaymentDetails = async (patientId: string ): Promise<ResponseType<patientPayDetailsBIllsNoAndDates |null>> => {
  try {
    const result = await instance.get(`${cashierApi.patientientPaymentDetails}?patientId=${patientId}`, {
  }); 
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getBilledDetailsService = async (data: {
  billId: number;
}): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getbilledItemdetails, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};


export const getBilledDetailsServiceV2 = async (data: {
   billId: number[];
  insname:string;
  
}): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getbilledItemdetailsPartialPay, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export type BilledDetailsRequest = {
  billId: number | number[];
  insname?: string;
};

/** Routes to v1 (CPT) or v2 billed-details API based on logged-in user codetype. */
export const getBilledDetailsForUser = async (
  data: BilledDetailsRequest,
): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
  const { user } = getConstants();

  if (user?.codetype === "CPT") {
    const billId = Array.isArray(data.billId) ? data.billId[0] : data.billId;
    if (!billId) return emptyError;
    return getBilledDetailsService({ billId });
  }

  const billIds = Array.isArray(data.billId) ? data.billId : [data.billId];
  return getBilledDetailsServiceV2({
    billId: billIds,
    insname: data.insname ?? "",
  });
};


export const getPatientLedgerData = async (data: {
  patientId: number;
  clinicId: number;
}): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
  try {
    const result = await instance.get(`${cashierApi.getLedgerData}?patientId=${data.patientId}&clinicId=${data.clinicId}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPatientLedgerDetails = async (params: { 
  clinicId: number, 
  emrNo: string, 
  filter: { search: string, pageSize: number, pageNo: number } 
}): Promise<ResponseType<any[]>> => {
  try {
    // result sends the params object directly as the body
    const result = (
      await instance.post(`${cashierApi.getPatientLedgerData}`, params)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}

// export const getPatientLedgerDetails = async (data: {
//   patientId: number;
//   clinicId: number;
// }): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
//   try {
//     const result = await instance.get(`${cashierApi.getPatientLedgerData}?patientId=${data.patientId}&clinicId=${data.clinicId}`);
//     return result.data;
//   } catch (error) {
//     return emptyError;
//   }
// };

export const addPaymentService = async (
  data: PaymentData,
): Promise<ResponseType<any>> => {
  return (await instance.post(cashierApi.AddPayment, { ...data, clinicId }))
    .data;
};

export const addPaymentPartialPayService = async (
  data: PaymentData,
): Promise<ResponseType<any>> => {
  return (await instance.post(cashierApi.AddPaymentPartialPay, { ...data, clinicId }))
    .data;
};

export const getPrintService = async (
  id: number,
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${cashierApi.getPrint}?cashierId=${id}&clinicId=${clinicId}`,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPrintServicev2 = async (
  id: number,
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${cashierApi.getPrintv2New}/${id}`,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPrintServicev2New = async (
  id: number,
  cashSplitId: number,
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${cashierApi.getPrintv2New}/${id}?cashSplitId=${cashSplitId}`,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteCashierService = async (body: {
  cashierId: number;
  paymentId: number;
  userId: number;
  clinicId?: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${cashierApi.delete}`, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteCashierServiceV2 = async (body: {
  cashierId: number;
  paymentId: number;
  userId: number;
  clinicId?: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${cashierApi.deleteV2}`, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
